import React from 'react';

export const PAGE_SIZE_OPTIONS = [10, 20, 30, 40, 50, 100];

function ListingPagination({ page, pageSize, total, onPageChange, onPageSizeChange }) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  const safePage = Math.min(Math.max(1, page), totalPages);
  const firstItem = total === 0 ? 0 : (safePage - 1) * pageSize + 1;
  const lastItem = Math.min(safePage * pageSize, total);
  const pageItems = [];
  const visiblePages = new Set([1, totalPages, safePage - 1, safePage, safePage + 1]);
  let previous = 0;
  [...visiblePages].filter(value => value >= 1 && value <= totalPages).sort((a, b) => a - b).forEach(value => {
    if (previous && value - previous > 1) pageItems.push(`gap-${previous}`, value);
    else pageItems.push(value);
    previous = value;
  });

  return <div className="listing-pagination" aria-label="Table pagination">
    <div className="listing-pagination-summary"><strong>{firstItem}–{lastItem}</strong><span>of {total} enquiries</span></div>
    <div className="listing-pagination-controls">
      <button type="button" className="listing-pagination-arrow" onClick={() => onPageChange(safePage - 1)} disabled={safePage === 1} aria-label="Previous page">‹</button>
      <div className="listing-page-numbers">{pageItems.map(item => typeof item === 'string'
        ? <span key={item} className="listing-page-gap">…</span>
        : <button key={item} type="button" className={item === safePage ? 'active' : ''} onClick={() => onPageChange(item)} aria-current={item === safePage ? 'page' : undefined}>{item}</button>
      )}</div>
      <button type="button" className="listing-pagination-arrow" onClick={() => onPageChange(safePage + 1)} disabled={safePage === totalPages} aria-label="Next page">›</button>
      <label className="listing-page-size"><span>Rows</span><select value={pageSize} onChange={event => onPageSizeChange(Number(event.target.value))}>
        {PAGE_SIZE_OPTIONS.map(size => <option key={size} value={size}>{size}</option>)}
      </select></label>
    </div>
  </div>;
}

export default ListingPagination;
